{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/PAINAD",
	"name": "PAINAD",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "PAINAD-schaal",
	"purpose": "Meet pijn bij gevorderde dementie",
	"description": "Elk item wordt gescoord op een schaal van 0 tot 2. Wanneer de 5 scores worden opgeteld, varieert de totaalscore van 0 — geen pijn — tot 10 — ernstige pijn.",
	"item": [
		{
			"linkId": "185",
			"text": "Ademhaling",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "460",
						"display": "Normaal"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "461",
						"display": "Incidentele moeizame ademhaling - Korte periode van hyperventilatie"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "462",
						"display": "Luidruchtige moeizame ademhaling - Lange periode van hyperventilatie - Cheyne-Stokes ademhaling"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		},
		{
			"linkId": "187",
			"text": "Onrustgeluiden",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "463",
						"display": "Geen"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "464",
						"display": "Incidenteel kreunen of kermen - Zacht spreken met een negatieve of afkeurende toon"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "465",
						"display": "Herhaaldelijk angstig uitroepen - Luid kreunen of kermen - Huilen"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		},
		{
			"linkId": "189",
			"text": "Gezichtsuitdrukking",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "466",
						"display": "Glimlachend of nietszeggend (neutraal, ontspannen)"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "467",
						"display": "Droevig, bang, fronsen"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "468",
						"display": "Grimas"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		},
		{
			"linkId": "191",
			"text": "Lichaamstaal",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "469",
						"display": "Ontspannen"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "470",
						"display": "Gespannen - Overstuur op en neer stappen, ijsberen - Zenuwachtig bewegen"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "471",
						"display": "Verstard, gebalde vuisten, opgetrokken knieën - Wegtrekken of wegduwen, uithalen"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		},
		{
			"linkId": "193",
			"text": "Troostbaarheid",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "472",
						"display": "Niet nodig om te troosten"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "473",
						"display": "Afgeleid of gerustgesteld door stem of aanraking"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "474",
						"display": "Onmogelijkheid te troosten, af te leiden of gerust te stellen"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		}
	]
}
